import { render, staticRenderFns } from "./CitationAuthors.vue?vue&type=template&id=3039d6fc"
import script from "./CitationAuthors.vue?vue&type=script&lang=ts"
export * from "./CitationAuthors.vue?vue&type=script&lang=ts"
import style0 from "./CitationAuthors.vue?vue&type=style&index=0&id=3039d6fc&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports